import { render, staticRenderFns } from "./update-profile-icon.vue?vue&type=template&id=d08070a6&scoped=true&"
import script from "./update-profile-icon.vue?vue&type=script&lang=js&"
export * from "./update-profile-icon.vue?vue&type=script&lang=js&"
import style0 from "./update-profile-icon.vue?vue&type=style&index=0&id=d08070a6&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08070a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d08070a6', component.options)
    } else {
      api.reload('d08070a6', component.options)
    }
    module.hot.accept("./update-profile-icon.vue?vue&type=template&id=d08070a6&scoped=true&", function () {
      api.rerender('d08070a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/svg/update-profile-icon.vue"
export default component.exports